export default {"src":"/_next/static/media/financial-statement-hero-blank2.6ea5458c.svg","height":205,"width":175,"blurWidth":0,"blurHeight":0};